import { countriesChanged, connectedCountriesChanged } from "../../actions/filters";
import makeGroupedMultiSelect from "../../../../shared/make_grouped_multi_select";

export default  (purposeCountryParamMultiFilterMode = false) => {
  const valuesSelector = state => state.filters.countries.selectedValues;
  let optionsSelector = state => state.filters.countries.options;
  const title = purposeCountryParamMultiFilterMode ? "+ Add Countries / Organisations" : "Countries / Organisations";
  const changeCallback = purposeCountryParamMultiFilterMode ? connectedCountriesChanged : countriesChanged;
  let disabled;
  let stateBasedDisable;

  if (purposeCountryParamMultiFilterMode) {
    stateBasedDisable = state => state.filters.parameters.selectedValues.length === 0;
    optionsSelector = state => {
      const allOptions = state.filters.countries.options;
      const activePurposeId = state.filters.purpose.selectedValue.value;
      const activeParameterIds = state.filters.parameters.selectedValues.map(e => e.value);

      const countryParameterIds = state.countryParameterPurposeMap[activePurposeId];

      const countryIds = activeParameterIds.reduce((a, parameterId) => {
        return a.concat(countryParameterIds[parameterId]);
      }, []);

      const countryIdSet = new Set(countryIds);
      const options = allOptions.filter(e => {
        if (e.type !== "option") { return true; }
        return countryIdSet.has(e.value);
      });

      return options;
    };
  }

  return makeGroupedMultiSelect(changeCallback, title, valuesSelector, optionsSelector, { clearable: true, placeholder: "Choose country / organisation", disabled: disabled }, { "col-md-4": true }, false, false, stateBasedDisable);
};
